/* NUSA · LIVING DESIGN — interacciones del tema (sin dependencias). */
(function () {
  "use strict";

  /* ---------- Preloader ---------- */
  function initLoader() {
    var el = document.getElementById("nusa-loader");
    if (!el) return;
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      el.classList.add("done");
    }
    setTimeout(finish, 1400);
    setTimeout(finish, 4000);
    if (document.readyState === "complete") {
      setTimeout(finish, 400);
    } else {
      window.addEventListener("load", finish);
    }
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    function observeNew() {
      document.querySelectorAll(".reveal:not(.in)").forEach(function (el) { io.observe(el); });
    }
    observeNew();
    var mo = new MutationObserver(observeNew);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Header: solid on scroll + mobile menu + catalog dropdown ---------- */
  function initHeader() {
    var header = document.querySelector(".nusa-header");
    if (!header) return;
    var hasHero = header.dataset.hasHero === "true";
    var burger = header.querySelector(".nusa-burger");
    var mobileNav = header.querySelector(".nusa-mobile-nav");
    var catalog = header.querySelector(".nusa-catalog");
    var menuOpen = false;

    function applySolid() {
      var solid = window.scrollY > 60 || menuOpen || !hasHero;
      header.classList.toggle("is-solid", solid);
    }
    applySolid();
    window.addEventListener("scroll", applySolid, { passive: true });

    if (burger && mobileNav) {
      burger.addEventListener("click", function () {
        menuOpen = !menuOpen;
        burger.classList.toggle("is-open", menuOpen);
        mobileNav.classList.toggle("is-open", menuOpen);
        applySolid();
      });
    }

    if (catalog) {
      var closeTimer = null;
      var panel = catalog.querySelector(".nusa-catalog__panel");
      catalog.addEventListener("mouseenter", function () {
        if (closeTimer) clearTimeout(closeTimer);
        catalog.classList.add("is-open");
      });
      catalog.addEventListener("mouseleave", function () {
        closeTimer = setTimeout(function () { catalog.classList.remove("is-open"); }, 140);
      });
      if (panel) {
        panel.addEventListener("click", function (e) {
          var link = e.target.closest("a");
          if (link) catalog.classList.remove("is-open");
        });
      }
    }
  }

  /* ---------- Carrusel horizontal con snap + flechas + autoplay ---------- */
  function easeOutQuint(t) { return 1 - Math.pow(1 - t, 5); }

  function animateScrollTo(el, target, duration) {
    var start = el.scrollLeft;
    var distance = target - start;
    if (Math.abs(distance) < 1) return;
    var originalSnap = el.style.scrollSnapType;
    el.style.scrollSnapType = "none";
    var startTime = null;
    var token = (el._nusaScrollToken = (el._nusaScrollToken || 0) + 1);

    function step(now) {
      if (el._nusaScrollToken !== token) return;
      if (startTime === null) startTime = now;
      var t = Math.min((now - startTime) / duration, 1);
      el.scrollLeft = start + distance * easeOutQuint(t);
      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        el.style.scrollSnapType = originalSnap;
      }
    }
    requestAnimationFrame(step);
  }

  function initCarousels() {
    document.querySelectorAll("[data-nusa-carousel]").forEach(function (root) {
      var scroller = root.querySelector("[data-scroller]");
      if (!scroller) return;
      var autoplayMs = Number(root.dataset.autoplay || 0);
      var duration = 1100;
      var paused = false;
      var resumeTimer = null;

      function cardStep() {
        var card = scroller.querySelector("[data-card]");
        return (card ? card.offsetWidth : 360) + 16;
      }
      function advance(dir) {
        var step = cardStep();
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var target = scroller.scrollLeft + dir * step;
        if (target >= maxScroll - 4) target = maxScroll;
        if (target < 4) target = 0;
        if (dir === 1 && scroller.scrollLeft >= maxScroll - 4) target = 0;
        animateScrollTo(scroller, target, duration);
      }
      function pauseThenResume(ms) {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, ms || 5000);
      }

      root.querySelectorAll("[data-dir]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          advance(Number(btn.dataset.dir));
          pauseThenResume();
        });
      });
      scroller.addEventListener("mouseenter", function () { paused = true; });
      scroller.addEventListener("mouseleave", function () { paused = false; });
      scroller.addEventListener("touchstart", function () { paused = true; }, { passive: true });
      scroller.addEventListener("touchend", function () { pauseThenResume(); });

      if (autoplayMs > 0 && root.children.length && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        setInterval(function () { if (!paused) advance(1); }, autoplayMs);
      }
    });
  }

  /* ---------- Filtro de catálogo (buscar por nombre + "se está agotando") ---------- */
  function initCatalogFilter() {
    var grid = document.querySelector("[data-catalog-grid]");
    if (!grid) return;
    var input = document.querySelector("[data-catalog-search]");
    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-product-card]"));
    var emptyMsg = document.querySelector("[data-catalog-empty]");
    var params = new URLSearchParams(window.location.search);
    var lowStockOnly = params.get("agotando") === "1";

    function normalize(s) {
      return (s || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "");
    }

    function apply() {
      var q = normalize(input ? input.value : "");
      var visible = 0;
      cards.forEach(function (card) {
        var name = normalize(card.dataset.name);
        var isLow = card.dataset.lowstock === "true";
        var show = (!q || name.indexOf(q) !== -1) && (!lowStockOnly || isLow);
        card.style.display = show ? "" : "none";
        if (show) visible++;
      });
      if (emptyMsg) emptyMsg.style.display = visible === 0 ? "" : "none";
    }

    if (input) {
      var t;
      input.addEventListener("input", function () {
        clearTimeout(t);
        t = setTimeout(apply, 200);
      });
    }
    apply();
  }

  /* ---------- Filtro de blog por categoria (?tag=) ---------- */
  function initBlogFilter() {
    var grid = document.querySelector("[data-blog-grid]");
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-post-card]"));
    var emptyMsg = document.querySelector("[data-blog-empty]");
    var chips = document.querySelectorAll("[data-blog-filters] [data-tag]");
    var activeTag = new URLSearchParams(window.location.search).get("tag") || "";

    var visible = 0;
    cards.forEach(function (card) {
      var tags = (card.dataset.tags || "").split(",");
      var show = !activeTag || tags.indexOf(activeTag) !== -1;
      card.style.display = show ? "" : "none";
      if (show) visible++;
    });
    if (emptyMsg) emptyMsg.style.display = visible === 0 ? "" : "none";

    chips.forEach(function (chip) {
      chip.classList.toggle("is-active", chip.dataset.tag === activeTag);
    });
  }

  /* ---------- Galería de producto ---------- */
  function initProductGallery() {
    document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-gallery-main]");
      var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          if (!main) return;
          main.src = thumb.dataset.full || thumb.querySelector("img").src;
          thumbs.forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  /* ---------- Formulario de contacto nativo de Shopify: feedback simple ---------- */
  function initContactForm() {
    var form = document.getElementById("ContactForm");
    if (!form) return;
    form.addEventListener("submit", function () {
      var btn = form.querySelector("button[type='submit']");
      if (btn) {
        btn.disabled = true;
        btn.textContent = btn.dataset.pendingLabel || "Enviando…";
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initLoader();
    initReveal();
    initHeader();
    initCarousels();
    initCatalogFilter();
    initBlogFilter();
    initProductGallery();
    initContactForm();
  });
})();
